import { Paper } from '@mui/material';
import ReportChip from '../../../data-wrangler/components/QueryWizard/ReportChip';
import { colours } from '../../../../StyleConstants';
import { useSelector } from 'react-redux';
import { selectRunning } from '../../../data-wrangler/dataWranglerSlice';

const TabularDataSelection = () => {
    const isSummaryRunning = useSelector(selectRunning);
    return (
        <Paper sx={
            {
                minWidth: "20%",
                flexGrow: 1,
                padding: 3,
                height: '100%',
                backgroundColor: isSummaryRunning.active ? 'rgba(200,200,200,0.1)' : colours.core.white,
                overflow: "auto" // hack to deal with the graph destroying the layout when altering window dimension often
            }
        }>
            <ReportChip/>
        </Paper>
    )
}

export default TabularDataSelection;